import { render, staticRenderFns } from "./userMessage.vue?vue&type=template&id=9d2e50c0&scoped=true&"
import script from "./userMessage.vue?vue&type=script&lang=js&"
export * from "./userMessage.vue?vue&type=script&lang=js&"
import style0 from "./userMessage.vue?vue&type=style&index=0&id=9d2e50c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2e50c0",
  null
  
)

export default component.exports